import { useUserRole, ROLES, isSencoRole, isTeacherRole, isTaRole } from '../lib/auth/roles'

export default function useRole() {
  const { role, loading, error } = useUserRole({ subscribe: true })
  const isSENCO = isSencoRole(role)
  const isTeacher = isTeacherRole(role)
  const isTA = isTaRole(role)
  return { role, isSENCO, isTeacher, isTA, loading, error }
}

